import React from 'react';
import { Typography, Grid, Divider } from '@material-ui/core';
import LockSharpIcon from '@material-ui/icons/LockSharp';

import { COLOR_PRIMARY_DARK, exchangeRates, POINTER_GREEN } from 'src/const';

import { convertCurrency, formatCurrency, getLTMData, isListingLegacy } from 'src/utils/functions';
import { Listing, ListingLegacy, SampleEstimatorListingTypes } from 'src/interfaces/idashboard';
import { RecentlyAddedClockIcon } from './Chips/RecentlyAddedChip';

const PerformanceData = ({
  data,
  currency,
  // estimatorSampleListingData,
  handleOnSampleClick,
  isDisabled,
  isEstimator,
  isListingRecentlyAdded,
}: {
  data: any[] | Listing;
  currency: string;
  isDisabled: boolean;
  // estimatorSampleListingData?: SampleEstimatorListingTypes;
  handleOnSampleClick?: () => void;
  isEstimator:boolean;
  isListingRecentlyAdded: boolean;
}) => {
  const currencySymbol = exchangeRates[currency].symbol;
  // console.log('>>>>>>>>>>>isDisabled', isDisabled);
  // let revenuePotential = estimatorSampleListingData
  //   ? estimatorSampleListingData.revenuePotential
  //   : data['revenuePotential'];

  let revenuePotential = data['revenuePotential'];

  const formattedRevenue = `${currencySymbol}${formatCurrency(
    String(convertCurrency(currency, revenuePotential))
  )}`;

  let adr = -1;
  let occupancyRate = -1;
  // if (isListingLegacy(data)) {
  // adr = data.adr && data.adr.length > 0 ? getLTMData('adr', data.adr) : -1;
  // occupancyRate =
  // data.occupancy_rate && data.occupancy_rate.length > 0
  // ? getLTMData('occupancy_rate', data.occupancy_rate)
  // : -1;
  // } else {
  adr = data['adrLTM'] ? data['adrLTM'] : -1;
  occupancyRate = data['occupancyRateLTM'] ? data['occupancyRateLTM'] : -1;
  // }

  const formattedADR =
    adr !== -1 ? `${currencySymbol}${formatCurrency(String(convertCurrency(currency, adr)))}` : '-';
  const formattedOccupancyRate = occupancyRate !== -1 ? `${occupancyRate}%` : '-';

  return (
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      style={{ color: COLOR_PRIMARY_DARK }}
    >
      <Grid>
        <Typography
          color="textPrimary"
          variant="h6"
          align="center"
          style={{ color: POINTER_GREEN }}
        >
          {(!isDisabled  || isEstimator) ? (
            isListingRecentlyAdded ? <RecentlyAddedClockIcon />:`${formattedRevenue}`
          ) : (
            <LockSharpIcon
              style={{ fontSize: 24, color: POINTER_GREEN }}
              onClick={handleOnSampleClick}
            />
          )}
          {/* {formattedRevenue} */}
          <br />
        </Typography>
        <Typography color="textSecondary" variant="subtitle2" align="center">
          Revenue <br /> Potential <br />
        </Typography>
      </Grid>

      <Divider orientation="vertical" flexItem />

      <Grid>
        <Typography
          color="textPrimary"
          variant="h6"
          align="center"
          style={{ color: POINTER_GREEN }}
        >
          {!isDisabled ? (
            isListingRecentlyAdded ? <RecentlyAddedClockIcon />: `${formattedOccupancyRate}`
          ) : (
            <LockSharpIcon
              style={{ fontSize: 24, color: POINTER_GREEN, cursor: 'pointer' }}
              onClick={() => {
                handleOnSampleClick && handleOnSampleClick();
              }}
            />
          )}
          <br />
        </Typography>
        <Typography color="textSecondary" variant="subtitle2" align="center">
          Occupancy <br /> Rate (LTM) <br />
        </Typography>
      </Grid>

      <Divider orientation="vertical" flexItem />

      <Grid>
        <Typography
          color="textPrimary"
          variant="h6"
          align="center"
          style={{ color: POINTER_GREEN }}
        >
          {(!isDisabled  || !isEstimator) ? (
            isListingRecentlyAdded ? <RecentlyAddedClockIcon />: `${formattedADR}`
          ) : (
            <LockSharpIcon
              style={{ fontSize: 24, color: POINTER_GREEN, cursor: 'pointer' }}
              onClick={handleOnSampleClick}
            />
          )}
          <br />
        </Typography>
        <Typography color="textSecondary" variant="subtitle2" align="center">
          Median Nightly <br /> Rate (LTM) <br />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PerformanceData;
